module.exports = __webpack_public_path__ + "img/nft-line.d3c7c317.svg";